import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import NotificationsUI from '../../components/userSettings/NotificationsUI'

const NotificationsPageUI = ({context, messageList, errorList,
    // user notif
    emailAcceptance, submitted, onEmailAcceptanceChange,
    // project notif
    projectList, filteredProjectList, onProjectEmailAcceptanceChange,
    // refresh, filter
    onRefreshClick, searchFilter, onSearchFilterChange
  }) =>
  <PrivatePageSF context={context} className='pg_notif' backLink='/settings/user'
    messageList={messageList} headerMessageKey='c_email_notifications'
    centered={!projectList || !emailAcceptance || (errorList && errorList.length > 0)}
  >
    {
      (!projectList || !emailAcceptance) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      projectList && emailAcceptance &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/user'
          messageList={messageList} titleMessageKey='c_email_notifications'
        />
        <NotificationsUI
          context={context}
          messageList={messageList}
          // user notif
          submitted={submitted}
          emailAcceptance={emailAcceptance}
          onEmailAcceptanceChange={onEmailAcceptanceChange}
          // project notif
          projectList={projectList}
          filteredProjectList={filteredProjectList}
          onProjectEmailAcceptanceChange={onProjectEmailAcceptanceChange}
          // refresh, filter
          onRefreshClick={onRefreshClick}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      </div>
    }
  </PrivatePageSF>

export default NotificationsPageUI
